/**
 * カレンダー表示
 */

jQuery(function($) {
  // 元のテキストを保存するための変数を用意
  const originalTexts = {};

  // ウィンドウサイズのチェックとテキストの更新を行う関数
  function updateText() {
      $('.monthly-prev, .monthly-next').each(function() {
          const element = $(this).children();
          const elementId = $(this).attr('id') || $(this).index();

          if (window.matchMedia("(max-width: 767px)").matches) {
              // 767px以下の場合、元のテキストを保存してから更新
              if (!originalTexts[elementId]) {
                  originalTexts[elementId] = element.text(); // 元のテキストを保存
              }
              // 最初の5文字が既にカットされていない場合のみカット
              if (element.text().length > 5 && element.text() === originalTexts[elementId]) {
                  element.text(element.text().substring(5));
              }
          } else {
              // 768px以上の場合、元のテキストに戻す
              if (originalTexts[elementId]) {
                  element.text(originalTexts[elementId]);
              }
          }
      });
  }

  // ウィンドウサイズが変更されたときに関数を呼び出す
  $(window).resize(updateText);

  // ページ読み込み時にも関数を呼び出す
  updateText();
});

jQuery( function($) {
  // スクロール位置を保存する変数
  let savedScrollPos = 0;

  // リンクをクリックしたときのスクロール位置を保存
  $( '.monthly-prev a, .monthly-next a, .calendar-daylink' ).on( 'click', function() {
      savedScrollPos = $(window).scrollTop();
      localStorage.setItem('savedScrollPos', savedScrollPos);
  });

  // ページが読み込まれたときに以前のスクロール位置に戻る
  $( document ).ready( function() {
      if ( localStorage.getItem( 'savedScrollPos' )) {
          savedScrollPos = localStorage.getItem( 'savedScrollPos' );
          $( window ).scrollTop( savedScrollPos );
          localStorage.removeItem( 'savedScrollPos' ); // スクロール位置をリセット
      }
  });
});

